import React from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useIsCurrentUserDeviationAuthor } from '../../utils/hooks/useIsCurrentUserDeviationAuthor';
import LoadingIndicator from '../../LoadingIndicator';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import SubscribeButton from '../../Button/SubscribeButton';
import SubscribersOnly from '../../ActionBar/_partials/SubscribersOnly';
import Stats from '../../Stats';
import Benefit from '../../DeviationViews/TierProductCardDumb/Benefit';
import JournalTags from '../../DeviationViews/Details/_partials/JournalTags';
import Sidebar from '../../Sidebar';
import { isExtendedDeviationFullyLoaded } from '../redux/helpers';
import PanelPopup from '../_partials/PanelPopup';
import Comments from '../_partials/Comments';
import TierUpsell from '../_partials/TierUpsell';
import s from './MobileTierPage.scss';
var MobileTierPage = function (_a) {
    var deviation = _a.deviation;
    var isOwner = useIsCurrentUserDeviationAuthor(deviation);
    var isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    var _b = deviation.extended, _c = _b === void 0 ? {} : _b, tags = _c.tags, description = _c.description, _d = deviation.tier, _e = _d === void 0 ? {} : _d, _f = _e.benefits, benefits = _f === void 0 ? [] : _f;
    var member_subscriptions = useFlag('member_subscriptions');
    if (!member_subscriptions) {
        return null;
    }
    return (React.createElement("div", { className: s['root'] },
        React.createElement(ArtStage, { className: s['stage-content'], deviation: deviation }),
        React.createElement(ActionBar, { deviation: deviation }),
        React.createElement(PanelPopup, { deviation: deviation, actionBarType: "primary", className: s['large-popover-uplifted'] }),
        React.createElement("div", { className: s['details'] },
            !isOwner && (React.createElement(SubscribeButton, { className: s['subscribe-button'], tier: deviation, withPrice: true })),
            React.createElement("div", { className: s['subscribers-and-stats'] },
                React.createElement(SubscribersOnly, { deviation: deviation }),
                React.createElement(Stats, { deviation: deviation, withViewCount: false, withBadges: false })),
            isExtendedLoaded ? (React.createElement(React.Fragment, null,
                tags && React.createElement(JournalTags, { tags: tags }),
                React.createElement("p", { className: s['description'] }, description),
                React.createElement("ul", { className: s['benefits'] }, benefits.map(function (benefit) { return (React.createElement(Benefit, { key: benefit, benefit: benefit, className: s['benefit'] })); })),
                React.createElement(Comments, { deviation: deviation, className: s['comments'] }),
                React.createElement("div", { className: s['sidebar'] },
                    React.createElement(Sidebar, { deviation: deviation })))) : (React.createElement(LoadingIndicator, { className: s['lloader'], view: "llama" }))),
        React.createElement(TierUpsell, { className: s['upsell'], deviation: deviation })));
};
MobileTierPage.displayName = 'MobileTierPage';
export default MobileTierPage;
//# sourceMappingURL=MobileTierPage.js.map